import React, {VoidFunctionComponent} from 'react';

import SVGIcon, {SVGIconProps} from '../svg-icon/svg-icon';

export enum ArrowIconDirection {
  UP = 'up',
  RIGHT = 'right',
  DOWN = 'down',
  LEFT = 'left'
}

interface Props extends SVGIconProps {
  direction: ArrowIconDirection;
}

const ArrowIcon: VoidFunctionComponent<Props> = props => {
  const {direction, ...svgProps} = props;
  const rotation =
    (direction === ArrowIconDirection.DOWN && 90) ||
    (direction === ArrowIconDirection.LEFT && 180) ||
    (direction === ArrowIconDirection.UP && 270) ||
    0;

  return (
    <SVGIcon {...svgProps}>
      <path
        d="M22 12L18 8V11H3V13H18V16L22 12Z"
        fill="currentColor"
        transform={`rotate(${rotation}, 12, 12)`}
      />
    </SVGIcon>
  );
};
export default ArrowIcon;
